<template>
  <!-- Header Area wrapper Starts -->
  <header id="header-wrap ">

    <!-- Hero Area Start -->
    <div id="hero-area" class="hero-area-bg">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
            <div class="contents text-right">
              <h2 class="head-title rahLine position-relative d-inline-block ">تحصیلات تکمیلی </h2>
              <h4 class="head-title rahLine position-relative d-inline-block">کارشناسی ارشد و دکترا</h4>
              <p>{{ main }}</p>
              <div class="header-button">
                <a href="#" class="btn btn-common" @click="subShow(1)">ضرورت ایجاد رشته</a>
                <a href="#" class="btn btn-common" @click="subShow(0)">دوره و نظام گرایش ها</a>
              </div>
            </div>
          </div>
          <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
            <div class="intro-img">
              <img class="img-fluid" src="../assets/img/education.png" alt="تحصیلات تکمیلی">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 p-1">
            <p v-if="showText" class="bg-white p-3 mrRadius">
              {{ sub }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Hero Area End -->

  </header>
  <!-- Header Area wrapper End -->
</template>

<script>
import {mainText, subText1, subText2} from "../Data/graduateData";

export default {
  name: "GraduatePresentation",
  data() {
    return {
      showText1: false,
      showText2: false,
      showText: false,
      main: mainText,
      sub: "",
    }
  },
  methods: {
    subShow(id) {
      if (id === 1) {
        if (this.showText2) {
          this.showText = false;
          this.showText1 = false;
          this.showText2 = false;
        }
        this.showText1 = !this.showText1;
        this.showText = !this.showText && this.showText1;
        this.sub = subText1;
      }
      if (id === 0) {
        if (this.showText1) {
          this.showText = false;
          this.showText2 = false;
          this.showText1 = false;
        }
        this.showText2 = !this.showText2;
        this.showText = !this.showText && this.showText2;
        this.sub = subText2;
      }
    },
  },
}
</script>

<style scoped>
.mrRadius {
  border-radius: 20px;
}
</style>